export const baseUrl = process.env.REACT_APP_API_BASE || 'https://api.happihub.com/api/v1';
export const mallBaseUrl = process.env.RECT_MALL_BASE_URL || 'https://api.happihub.com/mall';
